// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import Button from "@insite/mobius/Button";
import React from "react";

interface Props {
    onClear: () => void;
    text?: string;
}
export const SearchButtonClearFilter: React.FC<Props> = ({ onClear, text = "Clear Filters" }) => {
    return (
        <Button onClick={onClear} data-test-selector="savedOrderList_clearFiltersButton" variant="tertiary">
            {translate(text)}
        </Button>
    );
};

export default SearchButtonClearFilter;
